export const lerp = (a: number, b: number, t: number) => {
  return a + t * (b - a)
}
